var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdc-tab-indicator",class:_vm.classes},[_c('span',{staticClass:"mdc-tab-indicator__content",class:_vm.contentClasses},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []

export { render, staticRenderFns }